/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ReleaseStatusFromJSON, ReleaseStatusToJSON, } from './ReleaseStatus';
/**
 * Check if a given object implements the ContentSearchRequest interface.
 */
export function instanceOfContentSearchRequest(value) {
    var isInstance = true;
    return isInstance;
}
export function ContentSearchRequestFromJSON(json) {
    return ContentSearchRequestFromJSONTyped(json, false);
}
export function ContentSearchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'active': !exists(json, 'active') ? undefined : json['active'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'releaseStatus': !exists(json, 'releaseStatus') ? undefined : ReleaseStatusFromJSON(json['releaseStatus'])
    };
}
export function ContentSearchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'active': value.active,
        'name': value.name,
        'url': value.url,
        'releaseStatus': ReleaseStatusToJSON(value.releaseStatus)
    };
}
